// Reine Darstellungslogik fuer die Magnetboard-Fahrzeugkarten.

const isMaschinist = (kuerzel) => /(^|[-_])MA$|(^|[-_])Ma$|Maschinist|(^|[-_])Fa$/i.test(kuerzel || '');
const isMve = (kuerzel) => /MVE|Beifahrer/i.test(kuerzel || '');
const isStaffelfuehrer = (kuerzel) => /^StF$/i.test(kuerzel || '');

const sortMagnetboardFunktionen = (funktionen = [], typCode = '') => {
  const sortiert = [...funktionen];

  if (String(typCode).toUpperCase() === 'LHF') {
    const maIndex = sortiert.findIndex(f => isMaschinist(f.kuerzel));
    const stfIndex = sortiert.findIndex(f => isStaffelfuehrer(f.kuerzel));
    if (maIndex >= 0 && stfIndex >= 0) {
      [sortiert[maIndex], sortiert[stfIndex]] = [sortiert[stfIndex], sortiert[maIndex]];
    }
    return sortiert;
  }

  if (String(typCode).toUpperCase() === 'RTW') {
    const mve = sortiert.filter(f => isMve(f.kuerzel));
    const ma = sortiert.filter(f => isMaschinist(f.kuerzel));
    const rest = sortiert.filter(f => !isMve(f.kuerzel) && !isMaschinist(f.kuerzel));
    return [...mve, ...rest, ...ma];
  }

  return sortiert;
};

const getMitfahrerImFahrzeug = (einteilungen = []) => einteilungen.filter(
  e => e?.funktion_kuerzel === 'ZUS'
);

const formatMitfahrerZusatz = (mitfahrer = []) => {
  const namen = mitfahrer
    .map(person => person?.aushilfe_user_name || person?.mitarbeiter_name)
    .filter(Boolean);
  return namen.map(name => `+ ${name}`).join(' · ');
};

const getMagnetboardIststaerke = (einteilungen = []) => einteilungen.filter(e => {
  const hatPerson = e?.mitarbeiter_id || e?.mitarbeiter_name || e?.aushilfe_user_name;
  const istMitfahrerOhneSitzfunktion = e?.funktion_kuerzel === 'ZUS';
  return hatPerson && !istMitfahrerOhneSitzfunktion;
}).length;
module.exports = {
  sortMagnetboardFunktionen,
  getMitfahrerImFahrzeug,
  formatMitfahrerZusatz,
  getMagnetboardIststaerke,
};
